import { Box } from '@mui/material';
import React, { ReactElement } from 'react';

interface OverlayProps {
  position: {
    top: number;
    right: number;
  };
  children: ReactElement;
  zIndex?: number;
}

const Overlay: React.FC<OverlayProps> = ({ position, children, zIndex = 21 }) => {
  return (
    <Box
      className="overlay"
      sx={{
        position: 'absolute',
        top: position.top,
        right: position.right,
        pointerEvents: 'auto',
        zIndex,
        display: 'flex',
        alignItems: 'center',
        gap: 1,
        // Ensure children are positioned relative to this container
        '& > *': {
          position: 'relative',
        },
      }}
    >
      {children}
    </Box>
  );
};

export default Overlay;
